/** @jsx jsx */
import { jsx } from '@emotion/core';

import React, { useEffect, useState } from 'react';
import { MultiSelect, MultiSelectOption } from '@americanexpress/dls-react';
import advFormStyles from '../../../styles/AdvancedFormSearch/AdvanceFormSearchStyles';
import { callApi } from '../../../utils';

const AdvFormMutilSelectItemV2 = React.memo(({
  formField, pageData, setPageData, loginData, acsMgmt,
}) => {
  const [suggestionList, setSuggestionList] = useState([]);

  const {
    id, name, selectedIds, apiPath,
  } = formField;

  const fetchListDataFromGetAPI = async () => {
    const { data, isError } = await callApi(acsMgmt + apiPath, 'GET', null, loginData);
    if (!isError) {
      return data || [];
    }
    return [];
  };

  useEffect(() => {
    fetchListDataFromGetAPI().then((data) => {
      setSuggestionList(data);
    });
  }, []);

  const handleOnChange = (selectedItemId, selected) => {
    const updatedPageData = { ...pageData };
    if (updatedPageData.formFields[id].selectedIds) {
      if (selected) {
        updatedPageData.formFields[id].selectedIds.push(selectedItemId);
      } else {
        const index = updatedPageData.formFields[id].selectedIds.indexOf(selectedItemId);
        if (index > -1) {
          updatedPageData.formFields[id].selectedIds.splice(index, 1);
        }
      }
      if (updatedPageData.formFields[id].selectedIds && updatedPageData.formFields[id].selectedIds.length > 0) {
        updatedPageData.formFields[id].value = updatedPageData.formFields[id].selectedIds.join(',');
      } else if (updatedPageData.formFields[id].nothingSelectedVal) {
        updatedPageData.formFields[id].value = updatedPageData.formFields[id].nothingSelectedVal;
      } else {
        updatedPageData.formFields[id].value = '';
      }
    }

    setPageData(updatedPageData);
  };

  const renderOptions = () => {
    const markup = [];
    console.log('in render options suggestionList');
    suggestionList.forEach((e) => markup.push(
      <MultiSelectOption
        key={e.id}
        id={e.id}
        selected={selectedIds.includes(e.id)}
        label={e.name}
        value={e.name}
      />
    ));
    return markup;
  };

  return (
    <div>
      <MultiSelect
        id={name}
        css={advFormStyles['.fullWidth']}
        onChange={(e, v) => handleOnChange(e, v)}
        style={{ zIndex: 'auto' }}
      >
        {renderOptions()}
      </MultiSelect>

    </div>
  );
});

export default AdvFormMutilSelectItemV2;
